import MatestackUiVueJs from "matestack-ui-vuejs";

const voucherValueTracker = {
  mixins: [MatestackUiVueJs.componentMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  data() {
    return {
      euroValue: 10.0,
      quantity: 1,
    }
  },
  methods: {
    updateEuroValue: function(payload) {
      const self = this

      self.euroValue = payload["euroValue"]
    },

    updateQuantityValue: function(payload) {
      const self = this

      self.quantity = payload["quantity"]
    }
  },
  computed: {
    formattedCurrency: function() {
      const self = this

      return `${self.quantity}x ${self.euroValue.toFixed(2)}€`
    }
  },
  mounted() {
    const self = this

    MatestackUiVueJs.eventHub.$on("euro-value-modified", self.updateEuroValue)
    MatestackUiVueJs.eventHub.$on("quantity-modified", self.updateQuantityValue)

  },

  beforeUnmount(){
    const self = this

    MatestackUiVueJs.eventHub.$off("euro-value-modified", self.updateEuroValue)
    MatestackUiVueJs.eventHub.$off("quantity-modified", self.updateQuantityValue)

  }
}

export default voucherValueTracker